import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/beginShow.svg'
import _imports_1 from '@/assets/images/red-packet-rain.png'


const _withScopeId = n => (_pushScopeId("data-v-6737976c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-red-packet" }
const _hoisted_2 = { class: "mobile-view" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = { class: "view-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "set-options" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "模式选择：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "现金模式，默认开启强制微信登录。", -1))
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下降选择：", -1))
const _hoisted_13 = {
  key: 0,
  class: "flex"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "红包金额：", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "元", -1))
const _hoisted_16 = {
  key: 1,
  class: "flex"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "领取人数：", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "个", -1))
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "持续时间：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "秒", -1))
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开始时间：", -1))
const _hoisted_24 = {
  key: 0,
  class: "prize-type"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "礼包图片：", -1))
const _hoisted_26 = { class: "img-upd" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "奖品名称：", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "奖品数量：", -1))
const _hoisted_29 = { class: "img-upd flex" }
const _hoisted_30 = { class: "web-bg" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "手机背景：", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
  /*#__PURE__*/_createTextVNode(" 750*1334小于2M "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("jpg , png, jpeg ")
], -1))
const _hoisted_33 = { class: "pc-bg" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "PC背景：", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
  /*#__PURE__*/_createTextVNode(" 1920*1080小于2M "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("jpg , png, jpeg ")
], -1))
const _hoisted_36 = {
  key: 0,
  class: "red-packet-img"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "红包图片：", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, [
  /*#__PURE__*/_createTextVNode(" 360*360小于2M "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("jpg , png, jpeg ")
], -1))
const _hoisted_39 = { class: "save-btn" }

import { ref, reactive, computed } from 'vue';
import { Moment } from 'moment';
import http from '@/api/redpacket';
import CUpload from '@/components/CUpload.vue';
import CDelModal from '@/components/CDelModal.vue';
import { Input, InputNumber, Radio, message, Popover, DatePicker } from 'ant-design-vue';

import { PlusCircleOutlined, QuestionCircleFilled, DeleteOutlined } from '@ant-design/icons-vue';
import { useStore } from 'vuex';

interface Options {
  label: string;
  value: number | '';
}

interface Condition {
  modeSelection: Options[]; // 模式选择
  directionSelection: Options[]; // 下降选择
}

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}

interface FileInfo {
  file: FileItem;
}
interface Form {
  type: number;
  id?: number;
  red_packed_amount: number;
  red_packed_num: number;
  continued_at: number;
  probability_winning: number;
  direction: number;
  pc_bg_id: any;
  mobile_bg_id: any;
  image_ids: any;
  goods_info: any;
  start_at: any;
  studio_id?: any;
}

interface Option {
  image_url: string;
  image_id: string;
  title: string;
  number: number;
  packetImg_loading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'createRedEnvelopeRain',
  props: {
    dataSource: null
  },
  emits: ['createStatus'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: any };

const aInput = Input;
const aRadioGroup = Radio.Group;
const aInputNumber = InputNumber;
const aPopover = Popover;
const aDatePicker = DatePicker;




const condition = reactive<Condition>({
  modeSelection: [
    { label: '现金', value: 1 },
    { label: '礼包', value: 2 },
  ],
  directionSelection: [
    { label: '左上', value: 1 },
    { label: '中间', value: 2 },
    { label: '右上', value: 3 },
  ],
});

const store = useStore();
const viewImgPlayerUrl = computed(() => {
  return store.state.home.customData.video_url;
});

const viewInfo = ref({
  pc_bg: process.env.VUE_APP_OTHER_LINK+'/6e02c202101081726212435.png',
  pc_bgImg_loading: false,
  web_bg: process.env.VUE_APP_OTHER_LINK+'/9970d202101081725475461.png',
  web_bgImg_loading: false,
  packet_img: process.env.VUE_APP_OTHER_LINK+'/8d081202101081747407993.png',
  packetImg_loading: false,
});

const createParams = ref<Form>({
  studio_id: '',
  type: 1, // 红包类型
  red_packed_amount: 0, // 红包金额
  red_packed_num: 0, // 红包个数
  continued_at: 20, // 持续时间
  probability_winning: 99, // 中奖概率
  direction: 1, // 下落方向
  pc_bg_id: 12, // 测试
  mobile_bg_id: 13, // 测试
  image_ids: 11, // 现金红包图片
  goods_info: '', // 礼包物品详情 [{'id':'','title':'黄马甲','number':'10','image_id':'10'}]
  start_at: '', // 发送时间
});

const packetOptions = ref<Option[]>([]);
packetOptions.value.push({
  image_url: '',
  image_id: '',
  title: '',
  number: 0,
  packetImg_loading: false,
});

const addPrizeOption = () => {
  packetOptions.value.push({
    image_url: '',
    image_id: '',
    title: '',
    number: 0,
    packetImg_loading: false,
  });
};

const delVisible = ref<boolean>(false);
const delIndex = ref();
const delPrizeOption = (index: number) => {
  delIndex.value = index;
  delVisible.value = true;
};
// 删除
const openDelModal = () => {
  delVisible.value = !delVisible.value;
};
// 确定删除
const okDelModal = () => {
  packetOptions.value.splice(delIndex.value, 1);
  openDelModal();
};

const onOk = (value: Moment) => {
  createParams.value.start_at = value.format('YYYY-MM-DD HH:mm');
};

// 获取红包雨详情
const getRedPackedRainInfo = () => {
  if (!props.dataSource.redPacketId) return;
  let params = {
    id: props.dataSource.redPacketId,
    studio_id: props.dataSource.studioId,
    type: props.dataSource.redPacketType,
  };
  http.getRedPackedRainInfo({ params }).then((res) => {
    if (res.data.code == 200) {
      createParams.value = res.data.data;
      createParams.value.image_ids = res.data.data.image_ids[0];
      viewInfo.value.pc_bg = res.data.data.pc_bg_url;
      viewInfo.value.web_bg = res.data.data.mobile_bg_url;
      viewInfo.value.packet_img = res.data.data.image_urls[0];
      if (res.data.data.type == 2) {
        packetOptions.value = res.data.data.goods_info;
        packetOptions.value.forEach((item: any) => {
          item['packetImg_loading'] = false;
        });
      }
    }
  });
};

// 添加红包雨
const saveRedPackRainInfo = () => {
  createParams.value.studio_id = props.dataSource.studioId;
  let fla = (createParams.value.red_packed_amount * 100) / createParams.value.red_packed_num;
  if (fla / 100 < 0.3 && createParams.value.type == 1) {
    message.error('单个金额不能小于0.3元');
    return;
  }
  if (createParams.value.type == 2) {
    let arr = JSON.parse(JSON.stringify(packetOptions.value));
    arr.forEach((item: any) => {
      delete item.packetImg_loading;
      delete item.image_url;
    });
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].title == '' || arr[i].image_id == '' || arr[i].number == '') {
        message.error('红包雨奖品信息不完整！');
        return;
      } else {
        var re = new RegExp('"', 'g');
        var fxg = new RegExp('\\\\', 'g');
        arr[i].title = arr[i].title.replace(fxg, '\\\\');
        arr[i].title = arr[i].title.replace(re, '\\"');
      }
    }
    createParams.value.goods_info = JSON.stringify(arr);
  } else {
    createParams.value.goods_info = '';
  }

  if (!createParams.value.id) {
    // 创建
    http
      .addRedPackRainInfo(createParams.value)
      .then((res) => {
        if (res.data.code == 200) {
          emit('createStatus', false);
          message.success(res.data.message);
        }
      })
      .catch((res) => {
        message.error(res.data.error);
      });
  } else {
    //  编辑
    http
      .updRedPackRainInfo(createParams.value)
      .then((res) => {
        if (res.data.code == 200) {
          emit('createStatus', false);
          message.success(res.data.message);
        }
      })
      .catch((res) => {
        message.error(res.data.error);
      });
  }
};
const fileList = ref([]);
const handleChange = (info: FileInfo, type: number, index: number) => {
  if (info.file.status === 'uploading') {
    type == 0
      ? (packetOptions.value[index].packetImg_loading = true)
      : type == 1
      ? (viewInfo.value.web_bgImg_loading = true)
      : type == 2
      ? (viewInfo.value.pc_bgImg_loading = true)
      : (viewInfo.value.packetImg_loading = true);
  } else {
    type == 0
      ? (packetOptions.value[index].packetImg_loading = false)
      : type == 1
      ? (viewInfo.value.web_bgImg_loading = false)
      : type == 2
      ? (viewInfo.value.pc_bgImg_loading = false)
      : (viewInfo.value.packetImg_loading = false);
  }

  if (info.file?.response?.code === 200) {
    message.success(info.file?.response?.message);
    let img_info = info.file?.response?.data;
    type == 0
      ? ((packetOptions.value[index].image_url = img_info.url), (packetOptions.value[index].image_id = img_info.id))
      : type == 1
      ? ((viewInfo.value.web_bg = img_info.url), (createParams.value.mobile_bg_id = img_info.id))
      : type == 2
      ? ((viewInfo.value.pc_bg = img_info.url), (createParams.value.pc_bg_id = img_info.id))
      : ((viewInfo.value.packet_img = img_info.url), (createParams.value.image_ids = img_info.id));
  }
  if (info.file.status === 'error') {
    message.error(info.file?.response?.error);
    type == 0
      ? (packetOptions.value[index].packetImg_loading = false)
      : type == 1
      ? (viewInfo.value.web_bgImg_loading = false)
      : type == 2
      ? (viewInfo.value.pc_bgImg_loading = false)
      : (viewInfo.value.packetImg_loading = false);
  }
};
const imageDel = (info: any, keywords: number) => {
  if (keywords === 1) {
    viewInfo.value.web_bg = '';
    createParams.value.mobile_bg_id = '';
  } else if (keywords === 2) {
    viewInfo.value.pc_bg = '';
    createParams.value.pc_bg_id = '';
  } else if (keywords === 3) {
    viewInfo.value.packet_img = createParams.value.image_ids = '';
  }
};
const init = () => {
  getRedPackedRainInfo();
};
init();

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(viewImgPlayerUrl),
          class: "kv-img"
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: viewInfo.value.web_bg
          }, null, 8, _hoisted_6),
          _createElementVNode("img", {
            class: "red-packet",
            src: _imports_1,
            style: _normalizeStyle(`transform:rotate(
            ${createParams.value.direction == 1 ? '-25deg' : createParams.value.direction == 2 ? '0deg' : '45deg'})`)
          }, null, 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_unref(aRadioGroup), {
            options: condition.modeSelection,
            value: createParams.value.type,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((createParams.value.type) = $event))
          }, null, 8, ["options", "value"]),
          (createParams.value.type == 1)
            ? (_openBlock(), _createBlock(_unref(aPopover), {
                key: 0,
                placement: "rightTop"
              }, {
                content: _withCtx(() => [
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_unref(aRadioGroup), {
            options: condition.directionSelection,
            value: createParams.value.direction,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((createParams.value.direction) = $event))
          }, null, 8, ["options", "value"])
        ]),
        (createParams.value.type == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_unref(aInputNumber), {
                value: createParams.value.red_packed_amount,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((createParams.value.red_packed_amount) = $event)),
                valueModifiers: { number: true },
                min: 0,
                precision: 2,
                step: "0.1",
                size: "small",
                style: {"width":"170px","height":"32px"}
              }, null, 8, ["value"]),
              _hoisted_15
            ]))
          : _createCommentVNode("", true),
        (createParams.value.type == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_unref(aInputNumber), {
                value: createParams.value.red_packed_num,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((createParams.value.red_packed_num) = $event)),
                valueModifiers: { number: true },
                min: 0,
                precision: 0,
                size: "small",
                style: {"width":"170px","height":"32px"}
              }, null, 8, ["value"]),
              _hoisted_18
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_unref(aInputNumber), {
            value: createParams.value.continued_at,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((createParams.value.continued_at) = $event)),
            valueModifiers: { number: true },
            min: 0,
            precision: 0,
            step: "1",
            size: "small",
            style: {"width":"170px","height":"32px"}
          }, null, 8, ["value"]),
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_unref(aDatePicker), {
            value: createParams.value.start_at,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((createParams.value.start_at) = $event)),
            "show-time": { format: 'YYYY-MM-DD HH:mm' },
            placeholder: "选择日期时间",
            onOk: onOk
          }, null, 8, ["value"])
        ])
      ])
    ]),
    (createParams.value.type == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _hoisted_25,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packetOptions.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "prize-item flex between",
              key: index + 'only'
            }, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(CUpload, {
                  "file-list": fileList.value,
                  "handle-change": (info) => handleChange(info, 0, index),
                  loading: item.packetImg_loading,
                  "image-name": item.image_url,
                  mask: false,
                  class: "ant_upload ant_upload_img1"
                }, null, 8, ["file-list", "handle-change", "loading", "image-name"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_27,
                _createVNode(_unref(aInput), {
                  value: item.title,
                  "onUpdate:value": ($event: any) => ((item.title) = $event),
                  style: {"width":"230px","height":"32px"},
                  placeholder: "请输入奖品名称"
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                _createVNode(_unref(aInputNumber), {
                  value: item.number,
                  "onUpdate:value": ($event: any) => ((item.number) = $event),
                  valueModifiers: { number: true },
                  min: 0,
                  precision: 0,
                  step: "1",
                  size: "small",
                  style: {"width":"150px","height":"32px"}
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _createVNode(_unref(PlusCircleOutlined), {
                onClick: addPrizeOption,
                class: "add-icon"
              }),
              (packetOptions.value.length > 1)
                ? (_openBlock(), _createBlock(_unref(DeleteOutlined), {
                    key: 0,
                    onClick: _withModifiers(($event: any) => (delPrizeOption(index)), ["stop"]),
                    class: "add-icon"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createVNode(CUpload, {
          "file-list": fileList.value,
          "handle-change": (info) => handleChange(info, 1),
          loading: viewInfo.value.web_bgImg_loading,
          "image-name": viewInfo.value.web_bg,
          "click-stop": (info) => imageDel(info, 1),
          class: "ant_upload ant_upload_img2"
        }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
        _hoisted_32
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createVNode(CUpload, {
          "file-list": fileList.value,
          "handle-change": (info) => handleChange(info, 2),
          loading: viewInfo.value.pc_bgImg_loading,
          "image-name": viewInfo.value.pc_bg,
          "click-stop": (info) => imageDel(info, 2),
          class: "ant_upload ant_upload_img3"
        }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
        _hoisted_35
      ]),
      (createParams.value.type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _hoisted_37,
            _createVNode(CUpload, {
              "file-list": fileList.value,
              "handle-change": (info) => handleChange(info, 3),
              loading: viewInfo.value.packetImg_loading,
              "image-name": viewInfo.value.packet_img,
              "click-stop": (info) => imageDel(info, 3),
              class: "ant_upload ant_upload_img4"
            }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"]),
            _hoisted_38
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createVNode(_component_a_button, {
        class: "mod_search_form_func",
        type: "primary",
        onClick: saveRedPackRainInfo
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ]),
    _createVNode(CDelModal, {
      visible: delVisible.value,
      centered: "",
      close: openDelModal,
      ok: okDelModal
    }, null, 8, ["visible"])
  ]))
}
}

})